import routesList from '#routes/guard/routeList';

const matchRoute = (path: string) => {
  const route = routesList.find((route) => new RegExp(`^${route.path}(/|$)`).test(path));

  const formatRoute = route?.children
    ? `${route?.path.replace('/*', '')}/${route?.children[0].path}`
    : `${route?.path.replace('/*', '')}`;

  return { path: formatRoute || '' };
};

export default matchRoute;
